import Semester from "../types/Semester";

export function hasNoCurriculumVersionsForExplore(
  role: number,
  selectedSemester: Semester,
  semesterVersions: unknown[],
  semesterVersionsLoading = false
): boolean {
  if (semesterVersionsLoading) return false;
  if (role === 1) return false;
  if (!selectedSemester?.label || selectedSemester.label === "All") return false;
  return !Array.isArray(semesterVersions) || semesterVersions.length === 0;
}

export function getNoCurriculumVersionMessage(
  programLabel?: string,
  semesterLabel?: string
): string {
  const program = programLabel?.trim() || "the selected program";
  const semester = semesterLabel?.trim() || "the selected semester";
  return `No curriculum version is available for ${program} and ${semester}.`;
}
